'use client';

import { AuthIntent } from '@/features/auth/internal/types/social-auth';
import { AccountProvider } from '@/features/auth/shared/types/account-providers';
import {
  SOCIAL_AUTH_EVENT_PARAM,
  SOCIAL_AUTH_PROVIDER_PARAM,
} from '@/shared/constants/search-params';

export const buildSocialAuthRedirectUrl = (
  targetUrl: string,
  intent: AuthIntent,
  provider: AccountProvider,
): string => {
  if (typeof window === 'undefined') {
    return targetUrl;
  }
  try {
    const origin = window.location.origin;
    const url = new URL(targetUrl, origin);
    url.searchParams.set(SOCIAL_AUTH_EVENT_PARAM, intent);
    url.searchParams.set(SOCIAL_AUTH_PROVIDER_PARAM, provider);
    return targetUrl.startsWith('http')
      ? url.toString()
      : `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return targetUrl;
  }
};
